import { render } from "./badgeComp.vue?vue&type=template&id=62f50550"
import script from "./badgeComp.vue?vue&type=script&lang=js"
export * from "./badgeComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__